import { createSlice } from '@reduxjs/toolkit';
import { IGetRestaurantResponse } from '../../proto/restaurant/restaurant';
import { IGetMenuResponse } from '../../proto/menu/menu';

interface IRestaurantState {
	restaurant: IGetRestaurantResponse;
	activeMenu: IGetMenuResponse;
}

const initialState: IRestaurantState = {
	restaurant: null,
	activeMenu: null,
};

export const { reducer } = createSlice({
	name: 'restaurant',
	initialState,
	reducers: {
		setRestaurant: (state, action) => {
			state.restaurant = action.payload;
		},
	},
});
